import React from 'react';
import CurrentUser from 'auth/CurrentUser';
import BoxBody from 'components/BoxBody';
import { Button } from 'components/ButtonDeprecated';
import Icon from 'components/Icon';
import Divider from 'components/Divider';
import Text, { TextColor, TextWeight } from 'components/Text';

import 'coaching/components/styles/SidebarHeader.scss';

export type Props = {
  title: string;

  // renders a back arrow if passed
  onBack?: () => void;
  // renders an "x" button if passed
  onClose?: () => void;

  // used for both button events, prepended to ".close.click" or ".back.click"
  eventPrefix?: string;
  // overrides `eventPrefix`; used as the FULL event string for the back button
  backEvent?: string;
  // overrides `eventPrefix`; used as the FULL event string for the close button
  closeEvent?: string;
};

export default function SidebarHeader({
  title,
  onBack,
  onClose,
  eventPrefix,
  backEvent,
  closeEvent,
}: Props) {
  const hasMultipleRecurringSessionsFeature =
    CurrentUser.isSignedIn() &&
    CurrentUser.getUser()?.hasFeature('add_recurring_sessions.web.dec-21');
  const titleColor = hasMultipleRecurringSessionsFeature ? 'black' : 'graphite';

  const closeEventKey = closeEvent ?? (eventPrefix ? `${eventPrefix}.close.click` : undefined);
  const backEventKey = backEvent ?? (eventPrefix ? `${eventPrefix}.back.click` : undefined);
  return (
    <>
      <BoxBody size="xsmall" className="SidebarHeader">
        {onBack && (
          <Button
            data-test="sidebar-header-back-button"
            className="SidebarHeader-back"
            eventKey={backEventKey}
            level="icon"
            color="chalkboard"
            onClick={onBack}>
            <Icon name="arrow-left" />
          </Button>
        )}
        <Text className="SidebarHeader-title" color={titleColor} weight="semibold">
          {title}
        </Text>
        {onClose && (
          <Button
            className="SidebarHeader-close"
            eventKey={closeEventKey}
            level="icon"
            color="chalkboard"
            onClick={onClose}>
            <Icon name="x" />
          </Button>
        )}
      </BoxBody>
      <Divider size="flush" />
    </>
  );
}
